import React, { useState } from 'react'
import Webcam from 'react-webcam'

const videoConstraints = {
    width: 400,
    height: 400,
    facingMode: 'user',
}
const Webcamera = (props) => {
    const [picture, setPicture] = useState('')
    const webcamRef = React.useRef(null)
    const capture = React.useCallback(() => {
        const pictureSrc = webcamRef.current.getScreenshot()

        setPicture(pictureSrc)
    })
    return (
        <div>
            <h2 className="mb-5 text-center">
                React Photo Capture using Webcam Examle
            </h2>
            <div>
                {picture == '' ? (
                    <Webcam
                        audio={props.audio}
                        height={props.height}
                        ref={webcamRef}
                        width={props.width}
                        screenshotFormat={props.screenshotFormat}
                        videoConstraints={videoConstraints}
                    />
                ) : (
                    <img src={picture} />
                )}
            </div>
            <div>
                {picture != '' ? (
                    <button
                        onClick={(e) => {
                            e.preventDefault()
                            setPicture('')
                        }}
                        className="btn btn-primary"
                    >
                        Retake
                    </button>
                ) : (
                    <button
                        onClick={(e) => {
                            e.preventDefault()
                            capture()
                        }}
                        className="btn btn-danger"
                    >
                        Capture
                    </button>
                )}
            </div>
        </div>
    )
}
export default Webcamera
